export default __webpack_public_path__ + "static/media/yellowstar.7829cd16.png";